<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>
            60. In unserer Organisation gibt es IT-gestützte Prozesse, um
            Daten...
          </h2>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "A060",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text:
            "In unserer Organisation gibt es IT-gestützte Prozesse, um Daten..."
        },
        xAxis: {
          categories: [
            "zu sammeln.",
            "",
            "für alle verfügbar zu machen.",
            "",
            "zu nutzen, um Angebote zu optimieren.",
            "zu nutzen, um die Zielerreichung zu überprüfen."
          ]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#546825", "#999", "#005a85"],
        series: [
          {
            name: "Ja",
            data: [57.8, null, 36.7, null, 34.1, 30.6]
          },
          {
            name: "In Ansätzen",
            data: [14.1, null, 17.5, null, 21.7, 21.3]
          },
          {
            name: "Nein",
            data: [28.1, null, 45.8, null, 44.2, 48.1]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
